export default __webpack_public_path__ + "static/media/Logo-With-White-BG.fce3e815.png";